import React from "react";
import { Aside } from "sprint-common-web";

import { EditVideoTechnicalInfoAsideContent } from "./EditVideoTechnicalAsideContent";

export interface EditVideoTechnicalAsideProps {
    fileRecordId: string;
    isOpen: boolean;
    onCancel(): void;
    onSubmit(): void;
}

export const EditVideoTechnicalAside: React.FC<EditVideoTechnicalAsideProps> = (
    props: EditVideoTechnicalAsideProps
) => {
    const { fileRecordId, isOpen, onSubmit, onCancel } = props;

    return (
        <Aside type="form" headerText="Edit technical info" isOpen={isOpen} onDismiss={onCancel} isLightDismiss={true}>
            <EditVideoTechnicalInfoAsideContent fileRecordId={fileRecordId} onCancel={onCancel} onSubmit={onSubmit} />
        </Aside>
    );
};
